import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import OrderConfirmation from "@/pages/OrderConfirmation";
import OrderTrack from "@/pages/OrderTrack";
import MyCredits from "@/pages/MyCredits";
import Shop from "@/pages/Shop";
import BookRepair from "@/pages/BookRepair";
import { useAuth } from "@/context/AuthContext";

function Protected({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/repair" element={<BookRepair />} />
        <Route path="/track" element={<OrderTrack />} />
        <Route path="/credits" element={<MyCredits />} />
        <Route path="/order/:orderId" element={<OrderConfirmation />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <Protected>
              <AdminDashboard />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
